import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const TermsGuests = () => {
  return (
    <div className="min-h-screen">
      <div 
        className="relative bg-cover bg-center py-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://customer-assets.emergentagent.com/job_elementor-site-1/artifacts/ff4gwxo8_ChatGPT%20Image%2031.%203.%202026%2023_45_22.png')`,
        }}
      >
        <Header />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-32 sm:pt-44 lg:pt-52 pb-4 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">Obchodní podmínky pro hosty</h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <Card className="shadow-xl">
          <CardHeader>
            <CardTitle className="text-3xl">Podmínky pro rezervace míst na WildCamping.cz</CardTitle>
            <p className="text-gray-600 mt-2">Platnost od: 1. ledna 2026</p>
          </CardHeader>
          <CardContent className="p-6 space-y-6">
            <section>
              <h2 className="text-2xl font-bold mb-3">1. Základní ustanovení</h2>
              <p className="text-gray-700 leading-relaxed">
                Těmito obchodními podmínkami se řídí vztah mezi provozovatelem platformy WildCamping.cz 
                a hosty, kteří si rezervují kempovací místa prostřednictvím této platformy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">2. Rezervace a platba</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Rezervace je závazná po potvrzení platby</li>
                <li>Platba je realizována online přes zabezpečenou platební bránu Stripe</li>
                <li>Cena zahrnuje náklady na ubytování + provizi platformy</li>
                <li>Po rezervaci obdržíte email s potvrzením a kontaktem na majitele</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">3. Storno podmínky</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Zrušení do 7 dnů před příjezdem:</strong> Vrácení 100% ceny</li>
                <li><strong>Zrušení 3-7 dnů před příjezdem:</strong> Vrácení 50% ceny</li>
                <li><strong>Zrušení méně než 3 dny před příjezdem:</strong> Bez vrácení peněz</li>
                <li>Storno žádost zasílejte na <a href="mailto:info@wildcamping.cz" className="text-orange-600 hover:underline">info@wildcamping.cz</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">4. Povinnosti hosta</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Dodržovat pravidla stanovená majitelem pozemku</li>
                <li>Respektovat tiché hodiny a pokyny pro používání ohniště</li>
                <li>Zanechat místo ve stejném stavu, v jakém jste ho převzali</li>
                <li>Nepoškozovat majetek ani přírodu v okolí</li>
                <li>Dodržovat počet osob uvedený v rezervaci</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">5. Co je zakázáno</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Hlučné chování po 22:00 hodině (pokud nejsou jiné podmínky)</li>
                <li>Zanechávání odpadu nebo znečištění lokality</li>
                <li>Používání otevřeného ohně v období sucha nebo zákazu</li>
                <li>Poškozování stromů, rostlin nebo majetku majitele</li>
                <li>Přivádění většího počtu osob než uvedeno v rezervaci</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">6. Hodnocení</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Po ukončení pobytu máte možnost ohodnotit pozemek a sdílet svou zkušenost. 
                Zároveň vás může ohodnotit majitel pozemku.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Hodnocení pomáhají ostatním hostům vybrat si správné místo a majitelům zlepšovat služby.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">7. Odpovědnost</h2>
              <p className="text-gray-700 leading-relaxed">
                Host je zodpovědný za škody způsobené na pozemku nebo majetku majitele. 
                Platforma WildCamping.cz nezodpovídá za ztráty, škody nebo úrazy vzniklé během pobytu.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">8. Bezpečnost</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Dbejte na vlastní bezpečnost a bezpečnost svých blízkých</li>
                <li>Dodržujte protipožární opatření</li>
                <li>V případě nouze volejte 112</li>
                <li>Informujte majitele o jakýchkoli problémech</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">9. Ochrana osobních údajů</h2>
              <p className="text-gray-700 leading-relaxed">
                Vaše osobní údaje jsou chráněny v souladu s GDPR. Používáme je pouze pro účely 
                rezervace a komunikace s majiteli pozemků.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">10. Kontakt a podpora</h2>
              <p className="text-gray-700 leading-relaxed">
                Pro dotazy nebo stížnosti kontaktujte náš tým na <a href="mailto:info@wildcamping.cz" className="text-orange-600 hover:underline">info@wildcamping.cz</a>
              </p>
            </section>

            <div className="mt-8 pt-6 border-t">
              <p className="text-sm text-gray-500">
                Přečetl/a jsem si a souhlasím s těmito obchodními podmínkami.
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Provedením rezervace souhlasíte s těmito podmínkami.
              </p>
              <Link to="/locations" className="text-orange-600 hover:text-orange-700 font-semibold mt-4 inline-block">
                → Prozkoumat místa
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>

      <Footer />
    </div>
  );
};

export default TermsGuests;